import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b6d1dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fv-plugins-message-container valid-feedback mt-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["required", "readonly"]
const _hoisted_12 = ["required", "readonly"]
const _hoisted_13 = ["required", "readonly"]
const _hoisted_14 = {
  key: 1,
  class: "fv-plugins-message-container invalid-feedback mt-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "spinner-border spinner-border-sm"
}, null, -1))
const _hoisted_17 = { class: "btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTooltip = _resolveComponent("InfoTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Object.keys(_ctx.infos).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infos, (info, key) => {
            return (_openBlock(), _createElementBlock("span", { key: key }, [
              _createTextVNode(_toDisplayString(info) + " ", 1),
              _hoisted_2
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass(["fs-5 fw-semibold mb-2", _ctx.required && 'required']),
            innerHTML: _ctx.label
          }, null, 10, _hoisted_4))
        : _createCommentVNode("", true),
      _createVNode(_component_InfoTooltip, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "tooltip", {}, undefined, true)
        ]),
        _: 3
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("input", {
        type: "hidden",
        name: "cvec_mail",
        id: "cvec_mail",
        value: _ctx.user.mail
      }, null, 8, _hoisted_6),
      _createElementVNode("input", {
        type: "hidden",
        name: "cvec_student_lastname",
        id: "cvec_student_lastname",
        value: _ctx.user.nom
      }, null, 8, _hoisted_7),
      _createElementVNode("input", {
        type: "hidden",
        name: "cvec_student_firstname",
        id: "cvec_student_firstname",
        value: _ctx.user.prenom
      }, null, 8, _hoisted_8),
      _createElementVNode("input", {
        type: "hidden",
        name: "cvec_student_dossier",
        id: "cvec_student_dossier",
        value: _ctx.dossiers[0]?.id
      }, null, 8, _hoisted_9),
      _createElementVNode("input", {
        type: "hidden",
        name: "cvec_year",
        id: "cvec_year",
        value: _ctx.admissibleInfos.formationYear
      }, null, 8, _hoisted_10),
      _createElementVNode("input", {
        type: "text",
        id: "cvec_number_1",
        class: _normalizeClass(["form-control form-control-solid", { disabled: _ctx.isSubmitting }]),
        maxlength: "4",
        required: _ctx.required,
        readonly: _ctx.readonly
      }, null, 10, _hoisted_11),
      _createElementVNode("input", {
        type: "text",
        id: "cvec_number_2",
        class: _normalizeClass(["form-control form-control-solid", { disabled: _ctx.isSubmitting }]),
        style: {"margin-left":"8px"},
        maxlength: "6",
        required: _ctx.required,
        readonly: _ctx.readonly
      }, null, 10, _hoisted_12),
      _createElementVNode("input", {
        type: "text",
        id: "cvec_number_3",
        class: _normalizeClass(["form-control form-control-solid", { disabled: _ctx.isSubmitting }]),
        style: {"margin-left":"8px"},
        maxlength: "2",
        required: _ctx.required,
        readonly: _ctx.readonly
      }, null, 10, _hoisted_13)
    ]),
    (Object.keys(_ctx.cvecErrors).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cvecErrors, (error, key) => {
            return (_openBlock(), _createElementBlock("span", { key: key }, [
              _createTextVNode(_toDisplayString(error) + " ", 1),
              _hoisted_15
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-primary btn-violet animated-submit mt-5", { disabled: _ctx.isSubmitting }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitCvec && _ctx.submitCvec(...args)))
    }, [
      _hoisted_16,
      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('global.buttons.send')), 1)
    ], 2)
  ], 64))
}